/**
 * A test persona the backend refused.
 *
 * In UAT the backend decides who may act as which test persona
 * (backend/shared/auth/persona_access.py) and answers 403 with a detail that starts
 * PERSONA_NOT_ALLOWED, PERSONA_TARGET_NOT_ALLOWED or PERSONA_NOT_SEEDED. Every later
 * request carries the same persona headers and would fail the same way while the header
 * still shows the persona as active, so the first refusal is announced and AuthProvider
 * drops the persona.
 */
export const PERSONA_REFUSED_EVENT = 'personaRefused'

export interface PersonaRefusal {
  code: string
  message: string
}

const REFUSAL_MESSAGES: Record<string, string> = {
  PERSONA_NOT_ALLOWED: 'Test personas are not enabled for your account.',
  PERSONA_TARGET_NOT_ALLOWED: 'That test persona is not one you can use.',
  PERSONA_NOT_SEEDED: 'That test persona has no record in this environment.',
}

/** The refusal carried by a response, or null when a 403 is about something else. */
export function personaRefusalFrom(status: number | undefined, detail: unknown): PersonaRefusal | null {
  if (status !== 403 || typeof detail !== 'string') return null
  const code = detail.split(':', 1)[0].trim()
  const message = REFUSAL_MESSAGES[code]
  return message ? { code, message: `${message} You are back on your own profile.` } : null
}

export function announcePersonaRefusal(refusal: PersonaRefusal): void {
  window.dispatchEvent(new CustomEvent<PersonaRefusal>(PERSONA_REFUSED_EVENT, { detail: refusal }))
}
